import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import Tooltip from '.'
import ButtonBase from '../button-base'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/Tooltip', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

const btnStyles = {
  'backgroundColor': '#ff5000',
  'color': 'white',
  'display': 'inline-block',
  'position': 'relative',
  'minWidth': '50px',
  'padding': '3px 20px',
  'fontFamily': 'Knowledge2017,arial,helvetica,clean,sans-serif',
  'fontStyle': 'normal',
  'fontWeight': '500',
  'fontSize': '15px',
  'lineHeight': '1.5',
  'textDecoration': 'none',
  'border': '0',
  'borderRadius': '5px',
  'boxShadow': 'none',
  'whiteSpace': 'nowrap',
  'transitionProperty': 'background-color, border-color, color',
  'transitionDuration': '150ms',
  'transitionTimingFunction': 'ease'
}

const data = [
  {
    'text': 'Tooltip text here...'
  },
  {
    'text': 'This text is displayed inside a tooltip lorem ipsum dolor sit amet'
  },
  {
    'text': 'This medium sized text is displayed inside a tooltip to force going over the left edge'
  },
  {
    'text': 'Tooltip',
    'icon': 'play'
  }
]

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <div>
        <div style={{margin: '20px 0 40px 0'}}>
          Basic tooltip with default options
          <Tooltip {...data[0]} />
        </div>

        <div style={{margin: '40px 0'}}>
          This is another tooltip where the trigger is defined as the children of the Tooltip element
          <Tooltip {...data[1]}>
            <span style={{'textDecoration': 'underline'}}>read more...</span>
          </Tooltip>
        </div>

        <div style={{margin: '40px 0'}}>
          Another example of tooltip where its children element is the trigger, in this case, a button.
          <Tooltip {...data[1]}>
            <ButtonBase style={btnStyles}>button with tooltip...</ButtonBase>
          </Tooltip>
        </div>

        <div style={{margin: '40px 0'}}>
          <Tooltip {...data[2]} style={{'marginLeft': '0'}} />
          Another tooltip with some text
        </div>

        <div style={{margin: '40px 0 20px 0'}}>
          This is some text with a custom tooltip icon
          <Tooltip {...data[3]} />
        </div>

        <table style={{width: '100%', tableLayout: 'fixed', lineHeight: '2'}}>
          <tbody>
            <tr>
              <td style={{padding: '10px', border: '1px solid grey', width: '30%'}}>Tooltip where the children text is truncated</td>
              <td style={{padding: '10px', border: '1px solid grey', width: '20%'}}>
                <Tooltip {...data[1]} truncate={true} textStyle={{verticalAlign: 'top'}}>
                  Tooltip where the children text is truncated lorem ipsum dolor sit amet, consectetur adipisicing elit. At consequuntur dicta doloremque fuga id in itaque necessitatibus nisi possimus, quae quas sint sit vero! Dolore error minus optio quisquam sint.
                </Tooltip>
              </td>
              <td style={{padding: '10px', border: '1px solid grey', width: '20%'}}>...</td>
              <td style={{padding: '10px', border: '1px solid grey', width: '20%'}}>...</td>
              <td style={{padding: '10px', border: '1px solid grey', width: '10%'}}>...</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ThemeProvider>
  ))
